import { getLatLng, searchLocation } from '@utils/location';
import { getTopDestinations } from './getTopDestinations';

export type GeocodeContext = {
  region?: string;
  country?: string;
};

export const getCityLatLonByName = async (
  city: string,
  context?: GeocodeContext
) => {
  const topDestinations = getTopDestinations();

  const hasGeographicContext = Boolean(
    context?.region?.trim() || context?.country?.trim()
  );
  const query = hasGeographicContext
    ? [city, context?.region, context?.country]
        .map((part) => part?.trim())
        .filter(Boolean)
        .join(', ')
    : city;
  const parsedCity = city.split(',')[0].trim();

  const filteredTopDestination = hasGeographicContext
    ? undefined
    : topDestinations.find((destination) =>
        destination.name.toLowerCase().startsWith(parsedCity.toLowerCase())
      );

  if (filteredTopDestination) {
    return {
      Geometry: {
        lat: filteredTopDestination.lat,
        lon: filteredTopDestination.lon,
      },
      Label: filteredTopDestination.name,
    };
  }

  const searchResults = await searchLocation(query);

  const [cityData] = searchResults.filter((result) => result?.PlaceId);

  if (!cityData) {
    return null;
  }

  const { Geometry, Label } = await getLatLng(cityData.PlaceId);
  const [lon, lat] = Geometry.Point;
  return {
    Geometry: {
      lat,
      lon,
    },
    Label,
  };
};
